<template>
    <section class="mt-4 mb-4">
        <div class="container">
            <div class="row mt-5">
                <div class="offset-md-3 col-md-6">
                    <div class="block">
                        <div class="block-header text-center"
                            v-if="alert != false">
                            <span class="icon error">
                                <i class="fa fa-times"></i>
                            </span>
                            <h3 class="mt-3">Invalid Order</h3>
                            <p>{{ alert }}</p>
                        </div>
                        <div class="block-header text-center"
                            v-else>
                            <span class="icon success">
                                <i class="fa fa-check"></i>
                            </span>
                            <h3 class="mt-3">Order Successfully Placed</h3>
                            <p>Your order {{ '#'.id }} was successfully placed</p>
                        </div>
                        <div class="block-body">
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <a class="cta-btn" 
                                        :href="appUrl" 
                                        title="Homepage"
                                        v-if="alert != false">
                                        <i class="fa fa-home"></i>
                                        Homepage
                                    </a>
                                    <a class="cta-btn" 
                                        :href="appUrl+'/retailer/orders/'+id" 
                                        title="View Order"
                                        v-else>
                                        <i class="fa fa-shipping-fast"></i>
                                        View Order
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                fetched: false,
                alert: false,
            };
        },
        mounted() {
            this.fetchDetails();
        },
        methods: {
            fetchDetails() {
                var that = this;
                axios.get('api/validate-order/' + that.id)
                .then(function(response) {
                    that.alert = response.data.alert;
                    that.fetched = true;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
        }
    };
</script>
